import { APP_LEGACY_USER_AGENTS, APP_USER_AGENT_PREFIX } from 'core/variables/constant';

export function closeWebview() {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage('closeWebview');
  }
}

export function isNativeAppWebview() {
  const userAgent = navigator?.userAgent ?? '';

  return userAgent.includes(APP_USER_AGENT_PREFIX) || APP_LEGACY_USER_AGENTS.some((app) => userAgent.endsWith(app));
}
